
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { EventBus } from '@/utils/EventBus';
import { Config } from '@/utils/Config';

@Component({
  inject: {
    $validator: '$validator'
  }
})
export default class TextInputFormField extends Vue {
  @Prop() private sizeClass!: string;
  @Prop() private value!: any;
  @Prop() private id!: string;
  @Prop() private title!: string;
  @Prop() private hasError!: boolean;
  @Prop() private required!: boolean;
  @Prop() private elementTitle!: string;
  @Prop() private errorMessage!: string | null;
  @Prop() private customValidation!: string | null;
  @Prop() private placeholder!: string;
  @Prop() private type!: string;

  private theValue: any = '';

  private get validation(): string {
    let validation = '';
    
    if (this.required) {
      validation += 'required';
    }

    if (this.customValidation) {
      validation += '|' + this.customValidation;
    }
    return validation;
  }

  private get sizeClassGenerated(): string {
    return this.sizeClass !== undefined ? this.sizeClass : 'is-large';
  }

  private isInitialized: boolean = false;

  mounted() {
    this.theValue = this.value;
    this.isInitialized = true;
  }

  private onInputChange() {
    this.$nextTick(() => {
      this.$emit('change');
    });
  }    

  // Watch value change
  @Watch('value', { immediate: true, deep: true })
  private onValueChange(val: any) {
    if (this.isInitialized) {
      this.theValue = val;
    }
  }

  // Watch theValue change
  @Watch('theValue', { immediate: true, deep: true })
  private onTheValueChange(val: any) {
    if (this.isInitialized) {
      this.$emit('input', val);
    }
  }
}
